<template>
  <BarChart :chartData="chartDataCity"></BarChart>
</template>

<script>
import {mapGetters} from "vuex";
import BarChart from "./BarChart.vue";

export default {
  name: "StudentCourseGroupedByCourse",
  data: () => ({}),
  components: { BarChart },
  computed: {
    ...mapGetters({
      multiSemesterSelected: 'multiSemesterSelected',
      courseSelected: 'courses/getCourseSelected',
      placeSelected: 'places/getPlaceSelected',

      getStudentCourseGrouped: 'studentCourses/getStudentCoursesGrouped',
    }),
    chartDataCity() {
      let chartData = {labels: [], datasets: []};
      chartData.labels = this.getStudentCourseGrouped.cid.map(x => x.name.substring(0,40));
      chartData.datasets[0] = {
        backgroundColor: '#7979f8',
        label: 'Ilość studentów na kierunku',
      };
      chartData.datasets[0].data = this.getStudentCourseGrouped.cid.map(x => x.amount);
      return chartData;
    },
  },
  watch: {
    multiSemesterSelected() {
      this.getStudentCourses();
    },
    placeSelected() {
      this.getStudentCourses();
    },
    courseSelected() {
      this.getStudentCourses();
    }
  },
  methods: {
    getStudentCourses() {
      this.loading = true;
      this.$store.dispatch(
          'studentCourses/getStudentCoursesGrouped',
          {
            'date': this.multiSemesterSelected ? this.multiSemesterSelected.join(',') : '',
            'pid': this.placeSelected,
            'cid': this.courseSelected,
            'groupBy': 'cid'
          }
      ).then(() => {
        this.loading = false;
      });
    }
  },
  created() {
    this.getStudentCourses();
  },
}
</script>

<style>
</style>
